import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'fr8bot-web-menu-button-menu',
  templateUrl: './web-menu-button-menu.html',
  styleUrl: './web-menu-button-menu.scss',
  imports: [NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WebMenuButtonMenu {
  isSelected = input(false);
  href = input('');
}
